import React, {Component} from 'react';
import './verify-css.css';
import {Link} from 'react-router-dom';

export default class Verify extends Component {
    render() {
        return (
            <div id="ve-d">
                <div id="ve-d3a">
                    <div id="ve-d1a">
                        <Link to='/verified'>
                            <div id="ve-d2a">
                                Verified
                            </div>
                        </Link>
                    </div>
                    <div id="ve-d1c">
                        <Link to='/enter-email'>
                            <div id="ve-d2b">
                                Enter Email
                            </div>
                        </Link>
                    </div>
                </div>
                <div id="ve-d1b">
                    <h1>Verify</h1>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/auth/verify/Verify.js